module.exports = __webpack_public_path__ + "img/news.9b67bc4b.jpg";